/* eslint-disable import/prefer-default-export */

import {
  QUOTING_GOOGLE_MAP,
  QUOTING_ADDRESS_1,
  QUOTING_ADDRESS_2,
  QUOTING_SET_VEHICLE_PRICE,
  QUOTING_IS_GET_QUOTE,
  IS_DRAGGING_MAP,
  QUOTING_IS_NO_SERVICE,
} from '../constants';

export function setGoogleMap(map) {
  return dispatch =>
    dispatch({
      type: QUOTING_GOOGLE_MAP,
      payload: map,
    });
}

export function setQuotingMapLocation1(address) {
  return dispatch =>
    dispatch({
      type: QUOTING_ADDRESS_1,
      payload: address,
    });
}

export function setQuotingMapLocation2(address) {
  return dispatch =>
    dispatch({
      type: QUOTING_ADDRESS_2,
      payload: address,
    });
}
export function setVehiclePrice(price, vehicleType) {
  return dispatch =>
    dispatch({
      type: QUOTING_SET_VEHICLE_PRICE,
      price,
      vehicle: vehicleType,
    });
}
export function setQuotingIsGetQuoting(bool) {
  return dispatch =>
    dispatch({
      type: QUOTING_IS_GET_QUOTE,
      payload: bool,
    });
}
export function setIsDraggingMap(bool) {
  return dispatch =>
    dispatch({
      type: IS_DRAGGING_MAP,
      payload: bool,
    });
}
export function setIsNoQuotingService(bool) {
  return dispatch =>
    dispatch({
      type: QUOTING_IS_NO_SERVICE,
      payload: bool,
    });
}



// WEBPACK FOOTER //
// ./src/actions/quoting.js